import axios from "axios"
import { graphql, navigate, useStaticQuery } from "gatsby"
import React from "react"
import { useEffect, useState } from "react"
import CheckBox from "../../atoms/FormFields/checkBox"
import ConsentField from "../../atoms/FormFields/consentField"
import DefaultInput from "../../atoms/FormFields/defaultInput"
import RadioButton from "../../atoms/FormFields/radioButton"
import TextArea from "../../atoms/FormFields/textArea"
import "./Form.css"

export default function Form({ id, styles, title }) {
  const [form, setForm] = useState()
  const [result, setResult] = useState({})
  const [submitted, setSubmitted] = useState(false)
  const [error, setError] = useState()
  const [message, setMessage] = useState()
  const [entryId, setEntryId] = useState()
  const [currPage, setCurrPage] = useState(0)

  const data = useStaticQuery(graphql`
    query AllPagesQuery {
      allWpPage {
        edges {
          node {
            slug
            databaseId
          }
        }
      }
    }
  `)

  useEffect(() => {
    const token = btoa(
      `${process.env.GATSBY_GF_KEY}:${process.env.GATSBY_GF_SECRET}`
    )

    axios
      .get(`${process.env.GATSBY_GF_ENDPOINT}/forms/${id}`, {
        headers: {
          Authorization: `Basic ${token}`,
        },
      })
      .then(res => {
        setForm(res.data)
      })
  }, [])

  useEffect(() => {
    const formObj =
      form !== undefined ? Object.values(form?.confirmations)[0] : null
    const token = btoa(
      `${process.env.GATSBY_GF_KEY}:${process.env.GATSBY_GF_SECRET}`
    )

    if (submitted) {
      axios
        .post(
          `${process.env.GATSBY_GF_ENDPOINT}/entries/${entryId}/notifications`,
          {},
          {
            headers: {
              Authorization: `Basic ${token}`,
            },
          }
        )
        .then(res => {
          if (formObj?.type == "message" && res.status == 200) {
            setMessage(formObj?.message)
          } else if (formObj?.type == "page" && res.status == 200) {
            let page = data.allWpPage.edges.filter(
              p => p.node.databaseId == formObj?.pageId
            )
            navigate(`/${page[0].node.slug}/`)
          }
        })
    }
  }, [submitted])

  useEffect(() => {
    if (entryId !== undefined) {
      setSubmitted(true)
    }
  }, [entryId])

  const changeHandler = (val, id, type) => {
    if (result[id] !== "" && type == "checkbox") {
      setResult(prevState => {
        let obj = Object.assign({}, prevState)
        obj[id] = ""
        return { ...obj }
      })
    } else {
      setResult(prevState => {
        let obj = Object.assign({}, prevState)
        obj[id] = val
        return { ...obj }
      })
    }
  }

  const submitHandler = e => {
    e.preventDefault()

    const token = btoa(
      `${process.env.GATSBY_GF_KEY}:${process.env.GATSBY_GF_SECRET}`
    )
    const date = new Date()

    const dateString = `${date.getFullYear()}-${
      date.getMonth() + 1
    }-${date.getDate()} ${date.getHours()}:${date.getMinutes()}:${date.getSeconds()}`

    let postData = {
      form_id: id,
      date_created: dateString,
      created_by: 1,
      status: "active",
    }

    axios
      .post(
        `${process.env.GATSBY_GF_ENDPOINT}/entries`,
        {
          ...postData,
          ...result,
        },
        {
          headers: {
            Authorization: `Basic ${token}`,
          },
        }
      )
      .then(res => {
        res.status == 201
          ? // setSubmitted(true)
            setEntryId(res.data.id)
          : setError("Er is iets mis gegaan, probeer het nog eens.")
      })
  }

  const fields = form?.fields

  useEffect(() => {
    const obj = {}

    form?.fields.map((f, i) => {
      if (f.type !== "checkbox") {
        obj[f.id] = ""
      } else {
        for (let i = 0; i < f.choices.length; i += 1) {
          obj[`${f.id}.${i + 1}`] = ""
        }
      }
    })

    setResult(obj)
  }, [form])

  const steps = fields?.reduce((r, o) => {
    if (o.type === "section") return [...r, []]
    if (!r.length) return [[o]]

    r[r.length - 1].push(o)
    return r
  }, [])

  return (
    <div className={`${styles}`}>
      {title ? <h3 className="mb-[20px]">{form?.title}</h3> : null}
      {!submitted && fields !== undefined ? (
        <form onSubmit={submitHandler}>
          {steps[currPage]?.map(f => {
            switch (f.type) {
              case "textarea":
                return (
                  <TextArea data={f} changeHandler={changeHandler} key={f.id} />
                )
              case "radio":
                return (
                  <RadioButton
                    data={f}
                    changeHandler={changeHandler}
                    result={result}
                    key={f.id}
                  />
                )
              case "checkbox":
                return (
                  <CheckBox
                    data={f}
                    changeHandler={changeHandler}
                    result={result}
                    key={f.id}
                  />
                )
              case "section":
                return <div key={f.id}>Section</div>
              case "consent":
                return (
                  <ConsentField
                    data={f}
                    changeHandler={changeHandler}
                    key={f.id}
                  />
                )
              default:
                return (
                  <DefaultInput
                    data={f}
                    changeHandler={changeHandler}
                    key={f.id}
                  />
                )
            }
          })}
          {currPage !== steps.length - 1 && currPage > 0 ? (
            <div className="flex justify-between">
              <div
                className="bg-background rounded-full px-[23px] py-[19px] text-primary cursor-pointer inline"
                onClick={() => {
                  setCurrPage(currPage - 1)
                }}
              >
                Vorige
              </div>
              <div
                className="bg-accent rounded-t-[27px] rounded-r-[27px] px-[23px] py-[19px] text-white cursor-pointer inline"
                onClick={() => {
                  setCurrPage(currPage + 1)
                }}
              >
                Volgende
              </div>
            </div>
          ) : currPage == 0 && steps.length > 1 ? (
            <div
              className="bg-accent rounded-full px-[23px] py-[19px] text-white cursor-pointer inline-block"
              onClick={() => {
                setCurrPage(currPage + 1)
              }}
            >
              Volgende
            </div>
          ) : (
            <div className="flex justify-between">
              {steps.length > 1 ? (
                <div
                  className="bg-background rounded-t-[27px] rounded-r-[27px] px-[23px] py-[19px] text-primary cursor-pointer inline"
                  onClick={() => {
                    setCurrPage(currPage - 1)
                  }}
                >
                  Vorige
                </div>
              ) : null}
              {/* <input type="submit" value={form?.button.text} className="hq-form__submit"></input> */}
              <button className="hq-form__submit">
                <span>{form?.button.text}</span>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="18"
                  height="18"
                  viewBox="0 0 18 18"
                  fill="none"
                >
                  <path
                    d="M7.71252 3.05994L12.6025 7.94994C13.18 8.52744 13.18 9.47244 12.6025 10.0499L7.71252 14.9399"
                    stroke="#003763"
                    stroke-width="1.5"
                    stroke-miterlimit="10"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  ></path>
                </svg>
              </button>
            </div>
          )}
        </form>
      ) : submitted && message !== undefined ? (
        <p className="formMessage">{message}</p>
      ) : !submitted && error !== undefined ? (
        <p className="formError">{error}</p>
      ) : (
        <div className="">
          <div className="flex flex-col mb-4">
            <div className="animated-label animated-background mb-2"></div>
            <div className="w-full animated-background"></div>
          </div>
          <div className="flex flex-col mb-4">
            <div className="animated-label animated-background mb-2"></div>
            <div className="w-full animated-background"></div>
          </div>
          <div className="flex flex-col mb-4">
            <div className="animated-label animated-background mb-2"></div>
            <div className="w-full animated-background"></div>
          </div>
          <div className="flex flex-col mb-4">
            <div className="animated-label animated-background mb-2"></div>
            <div className="w-full animated-background animated-textarea"></div>
          </div>
          <div className="animated-submit animated-background mb-2"></div>
        </div>
      )}
    </div>
  )
}
